import {$, w} from './constants';
//Página Fondos Externos
function igualarAlturasFondosExternosBlocks() {
    var maxHeight = 0;

    // Resetear alturas
    $('.fondos-externos__types-block').css('height', 'auto');

    // Calcular la altura máxima
    $('.fondos-externos__types-block').each(function () {
        var thisHeight = $(this).outerHeight();
        if (thisHeight > maxHeight) {
            maxHeight = thisHeight;
        }
    });

    // Asignar altura máxima
    $('.fondos-externos__types-block').css('height', maxHeight + 'px');
}
$(document).ready(function () {
	if( $('.fondos-externos__types-block').length ){
		igualarAlturasFondosExternosBlocks();
	}
});
$(window).on('resize', function () {
    if( $('.fondos-externos__types-block').length ){
		igualarAlturasFondosExternosBlocks();
	}
});